import { render } from "./AdminUIPanel.vue?vue&type=template&id=315372b6&scoped=true&ts=true"
import script from "./AdminUIPanel.vue?vue&type=script&lang=ts"
export * from "./AdminUIPanel.vue?vue&type=script&lang=ts"

import "./AdminUIPanel.vue?vue&type=style&index=0&id=315372b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315372b6"]])

export default __exports__